// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"b8e431fe","915":"cedc8b53"}[chunkId] + ".chunk.css";
};